<!--
 * @Author: fengjiahua fenjiahua@qq.com
 * @Date: 2024-08-30 14:33:33
 * @LastEditors: fengjiahua fenjiahua@qq.com
 * @LastEditTime: 2024-09-02 16:45:27
 * @FilePath: \qctsw-vue\packages\app\src\server\modules\search\complaintItem..vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<script lang='ts' setup>
import { APP_ROUTER, cityName } from '@qctsw/common'
import { timeFormat } from '@qctsw/utils'
import type { CollectiveComplainResponse, ComplaintSearchResponse } from '~/server/types'

import { getIssueText, isOnlyRouteQueryKeyChange, useGetRouteQuery } from '~/shared/function'

withDefaults(defineProps<{
  list: ComplaintSearchResponse[]
}>(), {
  list: () => [],
})

function formatIssue(
  data: ComplaintSearchResponse['issues'],
): {
    content: string
    tips: string
  }[] {
  if (!data)
    return []
  return data.map((v) => {
    return {
      content: v.issueLabel,
      tips: v.fissueLabel,
    }
  })
}
</script>

<template>
  <div v-for="item, index in list" :key="index" class="border-b-1 border-slate-2 py-sm block">
    <NuxtLink :to="APP_ROUTER.complaintDetail(item.id)" class="hover:text-orange-6 flex">
      <UtilComplaintStatus v-if="!isNaN(Number(item.complainStatusCode))" :code="Number(item.complainStatusCode)" />
      <span class="text-blue-5 mr-0.5">
        <UtilQrcode :to="APP_ROUTER.complaintDetail(item.id)" />
      </span>
      <span class="font-bold line-clamp-1">{{ item.title }}</span>
    </NuxtLink>
    <span class="flex items-center flex-wrap text-3.5 my-sm gap-2">
      <!-- <span class="mr-6">
        品牌：{{ item.vendorName + item.seriesName }}
      </span> -->
      <span class="mr-6 flex  ">
        <BasicLabel :is-show-popover="false" :is-show-more="false" :data-list="formatIssue(item.issues)"> 问题：</BasicLabel>
      </span>
      <span v-if="item.dealerCityId" class=" mb-2">
        地区：{{ cityName(item.dealerCityId) }}
      </span>
    </span>
    <UtilContentTips
      :tips-data="{
        date: (item.createTime),
        favorCount: 0,
        lookCount: item.lookCount ?? 0 }"
    />
  </div>
</template>

<style lang='scss' scoped></style>
